import CATEGORIES from "../data/categories";
import PRODUCTS, { NEW_ARRIVAL_IDS } from "../data/products";
import { useApp } from "../context/AppContext";

/** Returns the item count for a given category id */
function getCategoryCount(catId) {
  if (catId === "new") return NEW_ARRIVAL_IDS.length;
  return PRODUCTS.filter((p) => p.cat === catId).length;
}

export default function CategoryCards() {
  const { navigate, setSearch } = useApp();

  const handleClick = (catId) => {
    setSearch("");
    navigate("products", catId);
  };

  return (
    <div className="cat-cards">
      {/* Skip the "all" entry — it's always accessible from the nav */}
      {CATEGORIES.filter((c) => c.id !== "all").map((cat) => (
        <div
          key={cat.id}
          className="cat-card"
          onClick={() => handleClick(cat.id)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && handleClick(cat.id)}
        >
          <div className="cat-card-icon">{cat.icon}</div>
          <div className="cat-card-name">{cat.label}</div>
          <div className="cat-card-count">{getCategoryCount(cat.id)} items</div>
        </div>
      ))}
    </div>
  );
}
